import React from 'react'
import { FiChevronDown } from "react-icons/fi";

const title = ["Mr", "Miss", "Mrs", "Ms"];

export const people = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const UserDetails = ({ form, errors, setFormField, type }) => {
  return (
    <div className="mx-auto rounded-2xl shadow-md bg-white border border-slate-200 overflow-hidden">
      {/* Header bar */}
      <div className="bg-gradient-to-r from-primary from-[80%] to-secondary px-6 py-4 text-white font-semibold text-lg md:text-xl">
        Booking Details
      </div>

      <div className="p-3 md:p-6">
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">

            {/* Title Select */}
            <div className="col-span-2">
              <label className="block mb-1.5 text-sm font-semibold text-slate-700">Title*</label>
              <div className="relative w-full">
                <select
                  name="title"
                  value={form.title}
                  onChange={(e) => setFormField("title", e.target.value)}
                  className={`w-full px-4 py-3 bg-slate-100 text-slate-800 rounded-xl focus:outline-none border-2 appearance-none transition-all placeholder:text-slate-400 font-medium ${errors?.some((error) => error.label === "title")
                      ? form.title.length
                        ? "border-slate-200 focus:border-primary/20 focus:bg-white"
                        : "border-red-500 bg-red-50/50 focus:border-red-500"
                      : "border-transparent focus:border-primary/20 focus:bg-white"
                    }`}
                >
                  {title.map((o, index) => (
                    <option key={index} className="text-slate-800">{o}</option>
                  ))}
                </select>
                <FiChevronDown className="absolute -translate-y-1/2 pointer-events-none right-4 top-1/2 text-primary w-5 h-5" />
              </div>
            </div>

            {/* First Name Input */}
            <div className="col-span-2 md:col-auto">
              <label className="block mb-1.5 text-sm font-semibold text-slate-700">First Name*</label>
              <input
                type="text"
                placeholder="name"
                name="firstName"
                value={form.first_name}
                onChange={(e) => setFormField("first_name", e.target.value)}
                className={`w-full px-4 py-3 bg-slate-100 text-slate-800 rounded-xl focus:outline-none border-2 transition-all placeholder:text-slate-400 font-medium ${errors?.some((error) => error.label === "first_name")
                    ? form.first_name.length
                      ? "border-slate-200 focus:border-primary/20 focus:bg-white"
                      : "border-red-500 bg-red-50/50 focus:border-red-500"
                    : "border-transparent focus:border-primary/20 focus:bg-white"
                  }`}
              />
            </div>

            {/* Last Name Input */}
            <div className="col-span-2 md:col-auto">
              <label className="block mb-1.5 text-sm font-semibold text-slate-700">Last Name*</label>
              <input
                type="text"
                placeholder="last name"
                name="lastName"
                value={form.last_name}
                onChange={(e) => setFormField("last_name", e.target.value)}
                className={`w-full px-4 py-3 bg-slate-100 text-slate-800 rounded-xl focus:outline-none border-2 transition-all placeholder:text-slate-400 font-medium ${errors?.some((error) => error.label === "last_name")
                    ? form.last_name.length
                      ? "border-slate-200 focus:border-primary/20 focus:bg-white"
                      : "border-red-500 bg-red-50/50 focus:border-red-500"
                    : "border-transparent focus:border-primary/20 focus:bg-white"
                  }`}
              />
            </div>

            {/* Email Input */}
            <div className="col-span-2 md:col-auto">
              <label className="block mb-1.5 text-sm font-semibold text-slate-700">Email*</label>
              <input
                type="text"
                placeholder="email"
                name="email"
                value={form.email}
                onChange={(e) => setFormField("email", e.target.value)}
                className={`w-full px-4 py-3 bg-slate-100 text-slate-800 rounded-xl focus:outline-none border-2 transition-all placeholder:text-slate-400 font-medium ${errors?.some((error) => error.label === "email")
                    ? form.email.length
                      ? "border-slate-200 focus:border-primary/20 focus:bg-white"
                      : "border-red-500 bg-red-50/50 focus:border-red-500"
                    : "border-transparent focus:border-primary/20 focus:bg-white"
                  }`}
              />
            </div>

            {/* Mobile Number Input */}
            <div className="col-span-2 md:col-auto">
              <label className="block mb-1.5 text-sm font-semibold text-slate-700">Mobile Number*</label>
              <input
                type="text"
                placeholder="last name"
                name="contact_no"
                value={form.contact_no}
                onChange={(e) => setFormField("contact_no", e.target.value)}
                maxLength={15}
                className={`w-full px-4 py-3 bg-slate-100 text-slate-800 rounded-xl focus:outline-none border-2 transition-all placeholder:text-slate-400 font-medium ${errors?.some((error) => error.label === "contact_no")
                    ? form.contact_no.length
                      ? "border-slate-200 focus:border-primary/20 focus:bg-white"
                      : "border-red-500 bg-red-50/50 focus:border-red-500"
                    : "border-transparent focus:border-primary/20 focus:bg-white"
                  }`}
              />
            </div>

            {/* People (conditional select) */}
            {type === "Park And Ride" && (
              <div className="col-span-2">
                <label className="block mb-1.5 text-sm font-semibold text-slate-700">People*</label>
                <div className="relative w-full">
                  <select
                    name="people"
                    value={form.no_of_peoples}
                    onChange={(e) => setFormField("no_of_peoples", e.target.value)}
                    className="w-full px-4 py-3 bg-slate-100 text-slate-800 rounded-xl focus:outline-none border-2 border-transparent focus:border-primary/20 focus:bg-white appearance-none transition-all placeholder:text-slate-400 font-medium"
                  >
                    {people?.map((p, index) => (
                      <option className="text-slate-800" key={index} value={p}>
                        {p}
                      </option>
                    ))}
                  </select>
                  <FiChevronDown className="absolute -translate-y-1/2 pointer-events-none right-4 top-1/2 text-primary w-5 h-5" />
                </div>
              </div>
            )}

          </div>
        </form>
      </div>
    </div>
  )
}

export default UserDetails